import React, { useState, useEffect, useMemo } from 'react';
import { Dialog, IconButton } from '@material-ui/core';
import Button from '../CustomButtons/Button';
import CustomInput from '../CustomInput/CustomInputValidate';
import { Close } from '@material-ui/icons';
import axios from 'store/axios/axios-rs';
import { clone, formatDate2, handleError } from '../../shared/utility';
import { debounce } from 'lodash';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import Loader from '../Loader/Loader';
import TableSmall from '../Table/TableSmall';

const CustomDialogRSChooser = (props) => {
    const [inputValue, setInputValue] = useState({
        illi_number: '',
        project_name: '',
        id: ''
    });
    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(false);
    console.log('result', result);

    // Search
    // illi_number, project_name, id (RS id)
    const search = async (field, value) => {
        setLoading(true);
        try {
            const response = await axios.get(`/rsheets_filtered?${field}=${value}`);
            setResult(response.data);
            setLoading(false);
            setInputValue({
                illi_number: '',
                project_name: '',
                id: ''
            })
        } catch (error) {
            handleError(error);
            setLoading(false);
        }
    };

    const style = {padding:20,marginTop:0};
    if (props.minHeight) style.minHeight = props.minHeight;

    console.log('CustomDialogRSChooser', props, result);

    return <Dialog 
      open={props.open}
      onClose={() => {
        props.close();
      }}
      keepMounted  
      maxWidth="md" 
      fullWidth={true}
    >
        <div className="close-btn" onClick={() => { props.close(); }}>
            <Close />
        </div>
      <div style={style}>
            <h3>Choose Routing Sheet</h3>
            <GridContainer>
                <GridItem xs={12} sm={6} md={4}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        if (inputValue) {
                            search('id',inputValue.id);
                        }
                    }}>
                        <CustomInput
                            label="Search RS by ID"
                            value={inputValue.id}
                            onChange={(e) => {
                                const newData = clone(inputValue);
                                newData.id = e.target.value;
                                setInputValue(newData);
                            }}
                            autoFocus={true}
                        />
                        <Button color="white"
                            onClick={() => {
                                if (inputValue) {
                                    search('id',inputValue.id);
                                }
                            }}
                        >
                            SEARCH BY ID
                        </Button>
                    </form>
                </GridItem>
                <GridItem xs={12} sm={6} md={4}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        if (inputValue) {
                            search('illi_number',inputValue.illi_number);
                        }
                    }}>
                        <CustomInput
                            label="Search RS by illi number"
                            value={inputValue.illi_number}
                            onChange={(e) => {
                                const newData = clone(inputValue);
                                newData.illi_number = e.target.value;
                                setInputValue(newData);
                            }}
                            autoFocus={true}
                        />
                        <Button color="white"
                            onClick={() => {
                                if (inputValue) {
                                    search('illi_number',inputValue.illi_number);
                                }
                            }}
                        >
                            SEARCH BY illi #
                        </Button>
                    </form>
                </GridItem>
                <GridItem xs={12} sm={6} md={4}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        if (inputValue) {
                            search('project_name',inputValue.project_name);
                        }
                    }}>
                        <CustomInput
                            label="Search RS by project name"
                            value={inputValue.project_name}
                            onChange={(e) => {
                                const newData = clone(inputValue);
                                newData.project_name = e.target.value;
                                setInputValue(newData);
                            }}
                            autoFocus={true}
                        />
                        <Button color="white"
                            onClick={() => {
                                if (inputValue) {
                                    search('project_name',inputValue.project_name);
                                }
                            }}
                        >
                            SEARCH BY PROJECT NAME
                        </Button>
                    </form>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <hr />
                    {loading && <Loader center={true} />}
                    {!loading && <div className="hover-table">
                        {result.length > 0 && <TableSmall 
                            tableHead={[<strong>ID</strong>,
                            <strong>Project Name</strong>,
                            <strong>Date Created</strong>, 
                            <strong>illi #</strong>,
                            <strong>Action</strong>
                        ]}
                            tableData={result.map(r => {
                                const json_data = r.json_data;
                                return [
                                    r.id,
                                    r.project_name,
                                    formatDate2(r.date_created),
                                    json_data.illi_number,
                                    <div>
                                        <IconButton
                                            onClick={() => {
                                                props.openRS(r);
                                            }}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </IconButton>
                                    </div>
                                ]
                            })}
                        />}
                        {result.length === 0 && <div className="mt-20"><em>No results</em></div>}
                    </div>}
                </GridItem>
            </GridContainer>
      </div>
    </Dialog>
  }

  export default CustomDialogRSChooser;